import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { baseColors, darkColors } from "../../theme/colors";
import { Flex } from "../Box";
import { Link } from "../Link";
import { StyledFooter, // StyledIconMobileContainer,
StyledList, StyledListItem, StyledText, StyledSocialLinks } from "./styles";
// import { ThemeSwitcher } from "../ThemeSwitcher";
// import LangSelector from "../LangSelector/LangSelector";
// import CakePrice from "../CakePrice/CakePrice";
// import { LogoWithTextIcon, ArrowForwardIcon } from "../Svg";
// import { Button } from "../Button";
// import { Colors } from "../..";
var MenuItem = function(_param) {
    var items = _param.items, props = _object_without_properties(_param, [
        "items"
    ]);
    return /*#__PURE__*/ _jsx(StyledFooter, _object_spread_props(_object_spread({
        p: [
            "10px 16px 50px",
            null,
            "46px 40px 34px 40px"
        ]
    }, props), {
        justifyContent: "center",
        children: /*#__PURE__*/ _jsxs(Flex, {
            flexDirection: "column",
            width: [
                "100%",
                null,
                "1200px;"
            ],
            children: [
                /*#__PURE__*/ _jsx(Flex, {
                    order: [
                        2,
                        null,
                        1
                    ],
                    flexDirection: [
                        "column",
                        null,
                        "row"
                    ],
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    mb: [
                        "42px",
                        null,
                        "36px"
                    ],
                    children: items === null || items === void 0 ? void 0 : items.map(function(item) {
                        var ref;
                        /*#__PURE__*/ return _jsxs(StyledList, {
                            children: [
                                /*#__PURE__*/ _jsx(StyledListItem, {
                                    children: item.label
                                }),
                                (ref = item.items) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                                    var label = param.label, href = param.href, _isHighlighted = param.isHighlighted, isHighlighted = _isHighlighted === void 0 ? false : _isHighlighted;
                                    return /*#__PURE__*/ _jsx(StyledListItem, {
                                        children: href ? /*#__PURE__*/ _jsx(Link, {
                                            href: href,
                                            target: "_blank",
                                            rel: "noreferrer noopener2",
                                            color: isHighlighted ? baseColors.warning : darkColors.text,
                                            bold: false,
                                            children: label
                                        }) : /*#__PURE__*/ _jsx(StyledText, {
                                            children: label
                                        })
                                    }, label);
                                })
                            ]
                        }, item.label);
                    })
                }),
                /*#__PURE__*/ _jsx(StyledSocialLinks, {
                    order: [
                        2
                    ],
                    pb: [
                        "38px",
                        null,
                        "32px"
                    ],
                    mb: [
                        "0",
                        null,
                        "32px"
                    ]
                })
            ]
        })
    }));
};
export default MenuItem;
